import { call, put, select } from 'redux-saga/effects';
import * as dialogService from '../../../dialog/dialog.saga-services';
import { apiRequest } from '../../../api/api.saga-services';
import * as userSettingsApi from '../../../api/request-config/user-settings.api';
import { IUserSetting } from '../../../resource/user-settings/user-settings.types';
import * as api from '../../../api/request-config/user-settings.api';
import * as actions from './user-settings.actions';
import { IUpdateUserSettingsData } from '../../../resource/user-settings/user-settings.types';
import { DropResult } from 'react-beautiful-dnd';
import { IUserWidgetVisibilityUpdate, IUpdateUserWidgetSize, IWidget } from './user-settings.types';
import { cutAndInstert } from '../../../../utils/dnd.utils';
import { userSettingsPageSelectors } from './user-settings.selectors';

export function* getUserSettings() {
  const userSettings = (yield call(apiRequest, api.getUserSettingsApi())) as IUserSetting;

  yield put(actions.storeUserSettings(userSettings));
}

export function* updateUserSettings(data: IUpdateUserSettingsData) {
  const userSettings = (yield call(apiRequest, userSettingsApi.updateUserSettingsApi(data))) as IUserSetting;
  if (!userSettings) {
    return;
  }

  yield put(actions.storeUserSettings(userSettings));
  yield call(dialogService.closeDialog, 'googleCalendarEmbedUrlFormDialog');
}

export function* updateUserWidgetVisibility(data: IUserWidgetVisibilityUpdate) {
  let userSettings = (yield select(userSettingsPageSelectors.selectUserSettings)) as IUserSetting;

  let widgets = userSettings?.widgets;

  widgets = widgets.map((widget) => {
    if (widget.key === data.key) {
      widget.visible = data.visibility;
    }
    return widget;
  });

  userSettings = (yield call(apiRequest, userSettingsApi.updateUserSettingsApi({ widgets }))) as IUserSetting;
  if (!userSettings) {
    return;
  }

  yield put(actions.storeUserSettings(userSettings));
}

export function* updateUserWidgetSize(data: IUpdateUserWidgetSize['payload']) {
  let userSettings = (yield select(userSettingsPageSelectors.selectUserSettings)) as IUserSetting;

  let widgets = userSettings?.widgets;

  widgets = widgets.map((widget) => {
    if (widget.key === data.key) {
      widget.size = data.size;
    }
    return widget;
  });

  userSettings = (yield call(apiRequest, userSettingsApi.updateUserSettingsApi({ widgets }))) as IUserSetting;
  if (!userSettings) {
    return;
  }

  yield put(actions.storeUserSettings(userSettings));
}

export function* reorderUserWidgets(result: DropResult) {
  if (!result.destination) {
    return;
  }
  const widgetKey = result.draggableId;
  const destinationIndex = result.destination.index;
  const sourceIndex = result.source.index;

  if (destinationIndex === sourceIndex) {
    return;
  }

  const userSettings = (yield select(userSettingsPageSelectors.selectUserSettings)) as IUserSetting;

  let widgets = userSettings?.widgets;

  const sourceMap = widgets.reduce((prev, curr) => {
    prev[curr.key] = curr;
    return prev;
  }, {} as { [key: string]: IWidget });

  if (!widgets || widgets[sourceIndex].key !== widgetKey) {
    return;
  }

  const [sourceKeys] = cutAndInstert(
    widgets.map((widget) => widget.key),
    sourceIndex,
    destinationIndex,
  );

  widgets = sourceKeys.map((key) => sourceMap[key]);

  const response = (yield call(apiRequest, userSettingsApi.updateUserSettingsApi({ widgets }))) as IUserSetting;
  if (!response) {
    return;
  }
  yield put(actions.storeUserSettings({ ...userSettings, widgets }));
}

export function* clearUserSettingsPageStorage() {
  yield put(actions.clearUserSettings());
}
